
/**
 * 통화 코드
 */
export type CourseDraftCreatePriceCurrency = typeof CourseDraftCreatePriceCurrency[keyof typeof CourseDraftCreatePriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftCreatePriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
